var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class TenantConfiguration {
  constructor(_data) {
    /**
     */
    __publicField(this, "AvailableBusinessTypes");
    /**
     */
    __publicField(this, "AvailableLanguages");
    /**
     */
    __publicField(this, "DefaultCompanySource");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof TenantConfiguration
     */
    __publicField(this, "$type", "V1.Companies.TenantConfiguration");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      if (_data["AvailableBusinessTypes"] && _data["AvailableBusinessTypes"].constructor === Array) {
        this.AvailableBusinessTypes = [];
        for (let item of _data["AvailableBusinessTypes"]) {
          this.AvailableBusinessTypes.push(TenantConfigurationAvailableBusinessTypes[item]);
        }
      }
      if (_data["AvailableLanguages"] && _data["AvailableLanguages"].constructor === Array) {
        this.AvailableLanguages = [];
        for (let item of _data["AvailableLanguages"]) {
          this.AvailableLanguages.push(item);
        }
      }
      this.DefaultCompanySource = _data["DefaultCompanySource"];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    if (this.AvailableBusinessTypes && this.AvailableBusinessTypes.constructor === Array) {
      _data["AvailableBusinessTypes"] = [];
      for (let item of this.AvailableBusinessTypes) {
        _data["AvailableBusinessTypes"].push(TenantConfigurationAvailableBusinessTypes[item]);
      }
    }
    if (this.AvailableLanguages && this.AvailableLanguages.constructor === Array) {
      _data["AvailableLanguages"] = [];
      for (let item of this.AvailableLanguages) {
        _data["AvailableLanguages"].push(item);
      }
    }
    _data["DefaultCompanySource"] = this.DefaultCompanySource;
    return _data;
  }
}
export var TenantConfigurationAvailableBusinessTypes = /* @__PURE__ */ ((TenantConfigurationAvailableBusinessTypes2) => {
  TenantConfigurationAvailableBusinessTypes2["Marketplace"] = "Marketplace";
  TenantConfigurationAvailableBusinessTypes2["Enterprise"] = "Enterprise";
  return TenantConfigurationAvailableBusinessTypes2;
})(TenantConfigurationAvailableBusinessTypes || {});
